import { useTranslation } from 'react-i18next';
import { theme } from '../../config/theme';

export function FeatureGrid() {
  const { t } = useTranslation();

  return (
    <section id="platform" className="bg-surface py-20">
      <div className="mx-auto max-w-7xl px-5 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <p className="text-sm font-semibold uppercase tracking-wide text-accent-foreground">{t('features.eyebrow')}</p>
          <h2 className="mt-3 text-3xl font-heading font-semibold tracking-normal text-foreground sm:text-4xl">
            {t('features.title')}
          </h2>
          <p className="mt-4 text-muted-foreground">
            {t('features.subtitle')}
          </p>
        </div>
        <div className="mt-12 grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {theme.features.map((feature) => {
            const Icon = feature.icon;
            return (
              <article key={feature.key} className="rounded-lg border border-border bg-surface p-6 text-surface-foreground">
                <div className="mb-5 grid size-11 place-items-center rounded bg-accent text-accent-foreground ring-1 ring-border">
                  <Icon className="size-5" />
                </div>
                <h3 className="text-base font-semibold text-foreground">{t(`features.items.${feature.key}.title`)}</h3>
                <p className="mt-2 text-sm leading-6 text-muted-foreground">{t(`features.items.${feature.key}.description`)}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
